export const GET_ALL_ENTITIES = '[ENTITY] GET_ALL_ENTITIES';
export const INITIATE = '[ENTITY] INITIATE';
